var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalkingAccidents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "724px",
    height: "650px",
    viewBox: "0 0 724 650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "walking3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "walking3",
    transform: "translate(0.230970, 12.429262)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#3BB1E6",
    strokeWidth: 22,
    cx: 482.26903,
    cy: 203.070738,
    rx: 48.5,
    ry: 45.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    transform: "translate(463.769030, 92.570738) rotate(-4.000000) translate(-463.769030, -92.570738) ",
    x: 453.76903,
    y: 70.5707376,
    width: 20,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    transform: "translate(529.769030, 97.570738) rotate(26.000000) translate(-529.769030, -97.570738) ",
    x: 519.76903,
    y: 75.5707376,
    width: 20,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    transform: "translate(576.990768, 143.461038) rotate(51.000000) translate(-576.990768, -143.461038) ",
    x: 565.490768,
    y: 119.961038,
    width: 23,
    height: 47
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#3BB1E6",
    strokeWidth: 24,
    points: "431.731622 215.076944 416.86197 206.070738 382.886935 146.461038 413.507324 35.3945453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.129164,55.422557 L412.507324,35.3945453 C407.043436,14.832237 397.777776,3.21087454 384.710344,0.530457874 C371.642913,-2.14995879 361.631571,5.32778295 354.676318,22.9636831 L322.398186,146.570738 L361.26903,229.631184 L241.873634,335.206803 L135.580094,273.68756",
    id: "Path-5",
    stroke: "#3BB1E6",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.580094,273.68756 C118.350908,265.04744 103.552207,269.3675 91.1839914,286.647739 L28.0755988,426.819576 C24.7133162,447.844774 29.2338129,461.418411 41.6370888,467.540486 C54.0403647,473.662562 64.5833516,471.381432 73.2660497,460.697097 C113.182419,388.658508 133.140603,352.639213 133.140603,352.639213 C133.140603,352.639213 161.594178,367.207194 218.501327,396.343156 L157.401958,442.614207 L59.2513751,569.231418 C46.423082,584.071339 46.423082,597.616102 59.2513751,609.865708 C72.0796682,622.115313 86.5831087,620.452494 102.761697,604.877249 L195.425628,502.055833 L314.796195,422.658198 L456.85957,312.070738 L558.623686,339.100977 L682.780388,292.418753 C693.956739,284.199789 696.750827,273.250451 691.162652,259.570738 C685.574476,245.891025 676.157392,239.956183 662.9114,241.766212 L562.952963,281.047331 L503.017495,263.932546 L487.654,252.128195",
    id: "Path-6",
    stroke: "#3BB1E6",
    strokeWidth: 24
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-7",
    stroke: "#3BB1E6",
    strokeWidth: 20,
    points: "563.210023 379.376447 499.569539 405.327873 586.689997 472.82043 488.234785 493.520315 494.852811 566.862839 422.76903 534.62794 391.343963 605.454248 349.376395 544.692805 298.401809 611.879081 289.326467 540.960889 232.268669 555.615258 252.544473 506.633855"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 494,
    y: 518,
    width: 229,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 0,
    y: 518,
    width: 91,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3BB1E6",
    x: 175,
    y: 518,
    width: 65,
    height: 21
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkingAccidents);
export default __webpack_public_path__ + "static/media/walking-accidents.0e2ca92cfd75337181e7edad998d9e94.svg";
export { ForwardRef as ReactComponent };